import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

type AlertReasonCellProps = {
  alertReason: string;
};

export const AlertReasonCell: React.FC<AlertReasonCellProps> = ({
  alertReason,
}) => {
  const [t] = useTranslation('alertManagement');

  const shortLabelMap: Record<string, string> = {
    HIGH_CABLE_TEMPERATURE: 'C. Temp.',
    CABLE_THEFT: 'C. Theft',
    LOWER_SESSION_COUNT: 'Low Sesion.',
    LOW_SESSION_ENERGY: 'Low Energy',
    OFFLINE: 'Offline',
    FAULTED: 'Faulted',
  };

  const shortLabel = shortLabelMap[alertReason] ?? t(alertReason);

  return (
    <Tooltip title={t(alertReason)}>
      <Chip
        label={shortLabel}
        sx={{
          backgroundColor: 'orange.light',
          color: 'error.dark',
          width: 120,
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  );
};
